import {Component, OnInit} from '@angular/core';
import {BlockAbstractComponent} from '@gallaghercp/core-frontend';

@Component({
    selector: 'core-one-page-callout',
    templateUrl: './one-page-callout.component.html',
    styleUrls: ['./one-page-callout.component.scss'],
    standalone: false
})

export class OnePageCalloutComponent extends BlockAbstractComponent implements OnInit {
    calloutImageURL = 'assets/img/callout_image.png';
}
